import { EventEnum } from "@/TS/Enums/global_enums";

export const EventTypeText: Map<EventEnum, string> = new Map([
  [EventEnum.MEETING, "Réunion"],
  [EventEnum.INTERVIEW, "Entretien"],
  [EventEnum.EVENT, "Événement"],
]);

export const EventTypeTitleText: Map<EventEnum, string> = new Map([
  [EventEnum.MEETING, "Modifier ma réunion"],
  [EventEnum.INTERVIEW, "Modifier mon entretien"],
  [EventEnum.EVENT, "Modifier mon événement annuel du Club d'Affaires"],
]);
